import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PurchaseShipmentService, ShipmentImportResult } from '../../../_services/purchase-shipment.service';
import { AlertService } from '../../../_services/alert.service';

export interface ShipmentImportPreviewData {
  fileName: string;
  shipments: any[];
  results: ShipmentImportResult[];
}

// What an import would do, shipment by shipment, before anything is saved.
// Closes with true once applied.
@Component({
    selector: 'app-shipment-import-preview',
    imports: [CommonModule, MatDialogContent, MatIconModule, MatProgressSpinnerModule],
    templateUrl: './shipment-import-preview.component.html'
})
export class ShipmentImportPreviewComponent {
  readonly dialogRef = inject(MatDialogRef<ShipmentImportPreviewComponent, boolean>);
  readonly data = inject<ShipmentImportPreviewData>(MAT_DIALOG_DATA);
  private shipmentService = inject(PurchaseShipmentService);
  private alertService = inject(AlertService);

  applying = false;

  get creates(): number {
    return this.data.results.filter((r) => r.action === 'create').length;
  }

  get updates(): number {
    return this.data.results.filter((r) => r.action === 'update').length;
  }

  get errorCount(): number {
    return this.data.results.reduce((n, r) => n + r.errors.length, 0);
  }

  get warningCount(): number {
    return this.data.results.reduce((n, r) => n + r.warnings.length, 0);
  }

  apply(): void {
    if (this.errorCount || this.applying) return;
    this.applying = true;
    this.shipmentService.importShipments({ dryRun: false, shipments: this.data.shipments }).subscribe({
      next: (response) => {
        this.applying = false;
        if (!response.applied) {
          this.data.results = response.results;
          this.alertService.alert('Something changed since the check - see the errors', 'error');
          return;
        }
        const parts = [this.creates ? `${this.creates} created` : '', this.updates ? `${this.updates} updated` : ''].filter(Boolean);
        this.alertService.alert(`Shipments imported - ${parts.join(', ')}`, 'success');
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.applying = false;
        this.alertService.alert(error?.error?.message || 'Import failed', 'error');
      },
    });
  }
}
